import { TariffV2Basic, TariffV2Option } from "@baloise-cfa/tsclient/fire";
import { atom } from "recoil";

import { persistAtom } from "../persist";

export const baseTariffState = atom<TariffV2Basic | undefined>({
    key: "baseTariffState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const optionTariffState = atom<TariffV2Option[]>({
    key: "optionTariffState",
    default: [],
    effects_UNSTABLE: [persistAtom],
});
